import React, {useEffect, useState} from 'react';
import {Typography, CircularProgress, Tooltip, Button} from '@mui/material';
import {Box} from '@mui/material';

import {

    colorText
} from "./theme.js";
import {

    getTokenNameByResourceId,
    isMobile,
    RESOURCE
} from "./utils";

import {formatMoney, formatMoneyCents, formatMoneyToString} from "../utils";

import AnimatedNumber from "../User/AnimatedNumber";

export const RenderBalances = ({ loadingBalances, balances, kbSubdomain }) => {
    const [displayCurrency, setDisplayCurrency] = useState(localStorage.getItem('displayCurrency') || 'USD');

    useEffect(() => {
        localStorage.setItem('displayCurrency', displayCurrency);
    }, [displayCurrency]);

    const toggleCurrency = () => {
        setDisplayCurrency(prevCurrency => prevCurrency === 'USD' ? 'Credits' : 'USD');
    };

    const typographyVariant = isMobile ? 'h8' : 'h6';

    const styleLoadingBox = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        marginLeft: isMobile ? '-20px' : '25%'
    };

    const styleBox = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        marginLeft: isMobile ? (kbSubdomain ? '35px' : '20px') : (kbSubdomain ? '20px' : '60px'),
        marginRight: '20px'
    };

    const balanceStyle = {
        cursor: 'pointer',
        fontSize: 14,
        textAlign: 'left',
        my: 0,
        mx: isMobile ? 0 : 2
    };

    const isUSD = displayCurrency === 'USD';

    const CREDIT = isUSD ? 'Credit' : 'Credits';

    const component = loadingBalances ? (
        <Box sx={styleLoadingBox}>
            <CircularProgress />
        </Box>
    ) : (
        <Box sx={styleBox}>
            {(balances?.length ? balances : [{balance: null, resourceId: RESOURCE.tokens}])
                .filter(o => [RESOURCE.tokens].includes(o.resourceId))
                .sort((a, b) => b.resourceId.localeCompare(a.resourceId))
                .map((balance, index) => (
                    <Tooltip
                        key={index}
                        title={
                            <>
                                {`${formatMoneyToString(balance?.balance)} ${getTokenNameByResourceId(RESOURCE.tokens)}`}
                                {isUSD && <><br />(Click to view credits)</>}
                            </>
                        }
                        placement="bottom"
                        enterTouchDelay={0}
                    >
                        <Typography variant={typographyVariant} component="p" sx={balanceStyle} onClick={toggleCurrency}>
                            {!isMobile && balance.balance !== null && <span style={{color: colorText}}>
                                {isUSD ? (kbSubdomain ? 'Application ' : 'User ') : ''}{CREDIT}: </span>}
                            <AnimatedNumber
                                hide={balance.balance === null}
                                number={balance.balance}
                                formatter={(amount) => isUSD ? formatMoneyCents(amount, '$', colorText) : formatMoney(amount, '', colorText)}
                            />
                        </Typography>
                    </Tooltip>
                ))}
        </Box>
    );

    return (
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'right', alignItems: 'center', height: '100%' }}>
            <Box sx={{
                width: '100%',
                maxWidth: 200,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
            }}>
                {component}
            </Box>
        </Box>
    );
};